module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.caption))]), _vm._v(" 服务\n    ")]), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.onSubmit,
      "reset": _vm.onReset
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "服务名",
      "label-for": "service_code"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "service_code",
      "options": _vm.services,
      "disabled": true
    },
    model: {
      value: (_vm.data.service_code),
      callback: function($$v) {
        _vm.$set(_vm.data, "service_code", $$v)
      },
      expression: "data.service_code"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label-for": "product_code",
      "label": "产品："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "id": "product_code"
    },
    model: {
      value: (_vm.data.product_code),
      callback: function($$v) {
        _vm.$set(_vm.data, "product_code", $$v)
      },
      expression: "data.product_code"
    }
  }, _vm._l((_vm.products), function(product) {
    return _c('el-option', {
      key: product.code,
      attrs: {
        "label": product.name,
        "value": product.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "实例名",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "name",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.$set(_vm.data, "name", $$v)
      },
      expression: "data.name"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "代号",
      "label-for": "code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "code",
      "type": "text",
      "placeholder": "选填",
      "disabled": _vm.isUpdate
    },
    model: {
      value: (_vm.data.code),
      callback: function($$v) {
        _vm.$set(_vm.data, "code", $$v)
      },
      expression: "data.code"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "实例URL",
      "label-for": "index_url"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "index_url",
      "type": "text"
    },
    model: {
      value: (_vm.data.index_url),
      callback: function($$v) {
        _vm.$set(_vm.data, "index_url", $$v)
      },
      expression: "data.index_url"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "上线时间",
      "label-for": "online_time"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "id": "online_time",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "type": "date"
    },
    model: {
      value: (_vm.data.online_time),
      callback: function($$v) {
        _vm.$set(_vm.data, "online_time", $$v)
      },
      expression: "data.online_time"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "简介",
      "label-for": "desc"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "desc",
      "rows": "3",
      "required": ""
    },
    model: {
      value: (_vm.data.desc),
      callback: function($$v) {
        _vm.$set(_vm.data, "desc", $$v)
      },
      expression: "data.desc"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "图片",
      "label-for": "img_url"
    }
  }, [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "size": "sm",
      "variant": "outline-success"
    },
    on: {
      "click": function($event) {
        return _vm.data.img_url.push('')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        return _vm.data.img_url.splice(-1, 1)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-minus"
  })])], 1)], 1), _vm._v(" "), _c('b-form-row', {
    staticClass: "mb-2"
  }, _vm._l((_vm.data.img_url), function(img_url, i) {
    return _c('image-upload', {
      key: i,
      attrs: {
        "id": "img_url",
        "fileObj": _vm.data.img_url[i]
      },
      on: {
        "update:fileObj": function($event) {
          return _vm.$set(_vm.data.img_url, i, $event)
        },
        "update:file-obj": function($event) {
          return _vm.$set(_vm.data.img_url, i, $event)
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "outline-primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" 提交")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "outline-danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" 返回")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-38f9892a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/demo/DemoCreate.vue
// module id = mHHk
// module chunks = 4